/**
 * Cart page — wraps shared CartSection with page-only init.
 */
(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cartPageInit === 'true') return;
    if (!window.tsCart || !window.tsCart.CartSection) return;
    sectionEl.dataset.cartPageInit = 'true';

    if (!sectionEl.dataset.sectionId) {
      sectionEl.dataset.sectionId = sectionEl.id.replace('shopify-section-', '');
    }

    var root = sectionEl.querySelector('[data-ts-cart-section]') || sectionEl;
    if (!root.getAttribute('data-section-id')) {
      root.setAttribute('data-section-id', sectionEl.dataset.sectionId);
    }

    new window.tsCart.CartSection(root, {
      source: 'cart-page',
      enableNote: true,
      enableExpand: true
    });
  }

  function initAll() {
    document.querySelectorAll('.section-cart-wrap').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.closest ? event.target.closest('.section-cart-wrap') : null;
    if (!wrapper && event.target.classList && event.target.classList.contains('section-cart-wrap')) {
      wrapper = event.target;
    }
    if (wrapper) {
      wrapper.dataset.cartPageInit = '';
      initSection(wrapper);
    }
  });
})();
